// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__29heA","col":"CardReaderDesc_col__1Wjbm","label":"CardReaderDesc_label__2c1OL"};